<script>
  import { onMount, tick } from 'svelte';
  import Zoom from './Zoom.svelte'
  import Article from './Article.svelte'
  import { getPgCount, getArticles, setArticles, setState, createArticle, splitBlock, setUrl } from './logic'
  import { logged, page, pagenum } from './stores'
	import Paging from './Paging.svelte';
  
  // export let issueId
  export let issue
  export let modified = false

  const index = 'articles'
  let pgCount = 2
  // let left = 1
  let right = 2
  let data
  let error
  let state
  //let logged = false
  // let userName = '', payload = ''
  let creating = false
  let newArtName = ''
  let ratified = '', excluded = ''
  let tonode
  
  onMount(async () => {
    await get()
  })
  
  async function get() {
    ({ error, data } = await getArticles(issue.id, index))
    console.log('get', data)
    
    if (data) {
      pgCount = getPgCount(data)
      await tick()
      modified = false
    }
  }

  async function setArticle() {
    error = await setArticles(data, issue.id, index)
    console.log('res1', error)
    if (!error) { 
      modified = false
      error = await setState(issue.id, 'checking', $logged)
      console.log('res1b', error)
    }
  }

  async function ratify() {
    error = await setArticle()
    console.log('res2', error)
    if (!error) error = await setState(issue.id, 'checked', $logged)
    console.log('res2b', error)
    if (!error) {
      ratified = 'shváleno'
      setTimeout(() => {$page = 'list'}, 1000)
    }
  }

  async function exclude() {
    error = await setState(issue.id, 'exclude', $logged)
    console.log('res3', error)
    if (!error) {
      excluded = 'vyřazeno'
      setTimeout(() => {$page = 'list'}, 1000)
    }
  }

  async function newArticle() {
    let articleID
    ({error, articleID} = await createArticle())
    console.log('res4', error)
    if (!error) {
      data.push({id: articleID, issue: issue.id, groups: [], rubric: false, rubricParts:[], keywords: [], class: [], authors: []})
      newArtName = '('+data.length+')'
      // data = data
      console.log('create', data.length, data)
      state = {index: data.length - 1, order: -1, new: true}
    }
  }

  async function split() {
    if (modified) error = await setArticle();
    if (error) return
    const line = {page: state.line.page, hpos: state.line.hpos, vpos: state.line.vpos, width: state.line.width, height: state.line.height}
    console.log('split', state.block, line)
    let res = await splitBlock(state.articleId, state.block, state.line)
    console.log('res5', res)
    if (res?.ok) {
      res = await setState(issue.id, 'checking', $logged)
      console.log('res5b', res)
      state = null
      data = null
      setTimeout(async () => {await get(); modified = false}, 1000)
    } else {      
      error = res.msg
      state = null
    }
  }


  let disp1 = 0 //, disp2 = 0
  let zoom1 = 0 //, zoom2 = 0
  let dispx1 = 50 //, dispx2 = 50
  
  // $: if (left < 1) left = 1
  // $: if (left > pgCount) left = pgCount
  $: right = $pagenum + 1
  $: if (right === $pagenum) right = $pagenum + 1
  $: if (data) modified = true
  $: if (state === null) newArtName = ''
</script>
  
<div class="flex justify-between">
  <div>
    Uloženo:
    <span class="ready" class:modified>{modified? 'ne' : 'ano'}</span>    
    <input type="button" class="btn btn-green py-0.5" value="uložit" on:click|preventDefault={setArticle} />
    {#if $pagenum === pgCount}
      <input type="button" class="btn btn-green py-0.5" value="schválit" on:click|preventDefault={ratify} />
      {#if ratified}<span class="success">{ratified}</span>{/if}
    {/if}
    {#if error}<span class="error">{error}</span>{/if}
  </div>
  
  <div class:right>
    {#if state?.line}
      podle <span class="split">{state.seq+1}</span>  
      <input type="button" class="btn btn-green py-0.5" value="rozdělit" on:click|preventDefault={split} />
    {:else if state?.from}
      od <span class="from">({state.index+1}) {state.order+1}</span> do bloku 
      <input type="number" class="input h-7" bind:this={tonode} value={state.order+1} min={state.order+1} max={data[state.index].groups.length} />
      <input type="button" class="btn btn-green py-0.5" value="ignorovat" on:click={() => {for (let i=state.order; i<tonode.value; i++) data[state.index].groups[i].isIgnored = true; state = null}} />
    {:else if creating}
      <span class="font-semibold">{newArtName}</span>  
      <input type="button" class="btn btn-green py-0.5" value="vytvořit" on:click|preventDefault={newArticle} />
    {:else}
      <input type="button" class="btn btn-green py-0.5" value="nový článek" on:click|preventDefault={() => creating = true} />
    {/if}
  </div>
</div>

<div class="state mb-2 h-8">
  Stav:
  {#if state}
    {#if state.reorder}
      {#if state.reorder === -1}  
        přeuspořádání bloků v článku <span class="from">({state.index+1})</span>
      {:else}
        určit blok <span class="from">({state.index+1}) {state.reorder+1}</span>
      {/if}
    {:else if state.from}
      zneplatnění části článku <span class="from">({state.index+1})</span>
    {:else if state.add}
      rozšíření článku <span class="from">({state.index+1})</span> za blok <span class="add">({state.index+1}) {state.order+1}</span>
    {:else if state.new}
      vytvoření nového článku <span class="from">({state.index+1})</span>
    {:else if state.split}
      rozdělení bloku <span class="font-semibold">{state.order+1}</span> článku <span class="from">({state.index+1})</span>
    {/if}
    <input type="button" class="btn btn-green py-0.5" value="přerušit / dokončit" on:click|preventDefault={() => state = null} />
  {/if}
  <!-- <input class="right" type="button" value="reset" disabled={!modified} on:click|preventDefault={get} /> -->
</div>
<!-- {JSON.stringify(data)} -->
<!-- {modified} {data?.length} {JSON.stringify(state)} {pgCount} {newArtName} -->

{#if data}	
  <div class="ln:flex">
    <div class="ln:w-1/2 ln:mr-2">
      <Zoom src="/issue/{issue.id}/{$pagenum}" bind:dispy={disp1} bind:zoom={zoom1} bind:dispx={dispx1}
          height="400" let:params
      >
        <!-- {JSON.stringify(params)} {issue.id} {$pagenum} -->
        <Article bind:articles={data} bind:state bind:error page={$pagenum} {...params} />
      </Zoom>
      <Paging id={issue.id} {pgCount} center/>
    </div>
    <div class="ln:w-1/2 ln:ml-2">
      <Zoom src="/issue/{issue.id}/{right}" hide={right > pgCount} nofocus let:params>
        <Article bind:articles={data} bind:state bind:error page={right} {...params} />
      </Zoom>
      <div class="flex justify-between mt-1">
        <span class="w-10">&nbsp;</span>
        <Paging bind:counter={right} {pgCount}/>
        <div class="">
          {#if excluded}<span class="success">{excluded}</span>{/if}
          <button type="button" class="btn btn-green" on:click={exclude}>vyřadit</button>
        </div>
      </div>
    </div>
  </div>
{/if}
    
<style>
  input[type=number] {
    width: 4em;
    padding: 5px;
    background-color:rgb(233, 233, 237);
  }
</style>